var _a;
export var Environment;
(function (Environment) {
    Environment["Local"] = "local";
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Production"] = "production";
})(Environment || (Environment = {}));
export var ENVIRONMENT_MAPPING = (_a = {},
    _a[Environment.Local] = 'local',
    _a[Environment.Development] = 'dev',
    _a[Environment.Staging] = 'staging',
    _a);
export var getEnvironment = function () {
    var hostname = window.location.hostname;
    var domainMatches = Object.values(Environment).filter(function (env) { return env !== Environment.Production && hostname.includes(ENVIRONMENT_MAPPING[env]); });
    return domainMatches.length === 0 ? Environment.Production : domainMatches.length === 1 ? domainMatches[0] : Environment.Development;
};
export var getUnleashEnvironment = function (environment) {
    if (environment === Environment.Local)
        return 'ED';
    if (environment === Environment.Development)
        return 'ED';
    if (environment === Environment.Staging)
        return 'Stage';
    if (environment === Environment.Production)
        return 'Production';
    else
        return 'ED';
};
//# sourceMappingURL=getEnvironment.js.map